export type ArtworkNatureOption = {
    code: string;
    description: string;
};

export const artworkNatureList = [
    { code: "001", description: "Livre publié à compte d'éditeur" },
    {
        code: "002",
        description:
            "Œuvre des arts graphiques et plastiques, sculpture, design et conception d'exposition - hors livre publié à compte d'éditeur et hors photographie",
    },
    {
        code: "003",
        description: "Photographie - hors livre publié à compte d'éditeur",
    },
    {
        code: "004",
        description: "Œuvre dramatique et textes non publiés sous forme de livre à compte d'éditeur",
    },
    {
        code: "005",
        description:
            "Scénario et dialogues (cinéma, audiovisuel, sonore et web) - hors livre publié à compte d'éditeur",
    },
    {
        code: "006",
        description: "Réalisation (cinéma, audiovisuel, sonore et web)",
    },
    {
        code: "007",
        description:
            "Traduction, adaptation, voice over (cinéma, audiovisuel, sonore et web) - hors livre publié à compte d'éditeur",
    },
    { code: "008", description: "Mise en scène, pantomimes" },
    {
        code: "009",
        description: "Œuvre musicale et textes liés non publiés sous forme de livre à compte d'éditeur",
    },
    {
        code: "010",
        description: "Œuvre chorégraphique dont partitions chorégraphiques",
    },
    { code: "011", description: "Œuvre scénographique" },
    {
        code: "012",
        description: "Jeux de société, jeux vidéo ou jeux de rôle - hors livre publié à compte d'éditeur",
    },
    {
        code: "013",
        description: "Production de presse - hors livre publié à compte d'éditeur",
    },
    { code: "014", description: "Autres" },
];
